export const scrollControl = {
    disableScroll: () => {
        document.body.style.overflow = 'hidden';
    },
    enableScroll: () => {
        document.body.style.removeProperty('overflow');
    },
};
